import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../service/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      const payload = this.authService.getTokenPayload();
      if (payload?.assignmentId) {
        return true;
      }
      // Autenticado pero sin asignación activa: limpiar sesión y volver al login
      this.authService.clearSession();
      return false;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
